"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var setup = function setup() {
  return {
    description: 'Add a schema that describes a GraphQL API.',
    flows: [{
      label: 'Upload a GraphQL API schema',
      fields: [{
        name: 'mainFile',
        inputType: 'file',
        classifier: 'graphql',
        extensions: ['.graphql'],
        required: true,
        hasMainFile: true,
        mainFileProperty: 'mainFile'
      }]
    }, {
      label: 'Upload an Apollo GraphQL API schema',
      fields: [{
        name: 'mainFile',
        inputType: 'file',
        classifier: 'graphql-apollo',
        extensions: ['.graphql'],
        required: true,
        hasMainFile: true,
        mainFileProperty: 'mainFile'
      }]
    }]
  };
};
var _default = exports.default = setup;
//# sourceMappingURL=form.js.map